const HERO_SELECTOR = [
  ".page-editions .editions-page__intro",
  ".journalism-page__intro",
  ".topics-page__hero",
  ".multimedia-page__intro",
  ".about-dev__intro",
  ".our-story-dev__intro-title-pin",
  ".team-dev__intro",
  ".team-page .team-hero",
  ".press-dev__intro",
  ".support-dev__intro",
  ".community-dev__intro",
  ".impact-dev--landing .impact-dev__intro",
  ".awards-dev__intro",
  ".newsletter-page__intro",
  ".events-page .events-intro",
  ".partnership-page__intro",
  ".speakers-bureau__intro",
  ".donate .donate-header",
  ".tag-archive__header"
].join(",");

const heroes = new Set();
let listenersReady = false;
let frame = 0;

function update() {
  frame = 0;

  heroes.forEach(hero => {
    if (!hero.isConnected) {
      heroes.delete(hero);
      return;
    }

    const followingSection = hero.nextElementSibling;
    const isPast = followingSection && followingSection.getBoundingClientRect().top <= 0;
    hero.classList.toggle("landing-hero-sticky--past", Boolean(isPast));
  });
}

function scheduleUpdate() {
  if (frame) return;
  frame = window.requestAnimationFrame(update);
}

export default function initLandingHeroSticky(root = document) {
  const found = [];

  if (root.matches?.(HERO_SELECTOR)) found.push(root);
  root.querySelectorAll?.(HERO_SELECTOR).forEach(hero => found.push(hero));

  found.forEach(hero => heroes.add(hero));

  if (!listenersReady && heroes.size) {
    window.addEventListener("scroll", scheduleUpdate, {passive: true});
    window.addEventListener("resize", scheduleUpdate, {passive: true});
    listenersReady = true;
  }

  scheduleUpdate();
}
